import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { withTranslation } from 'react-i18next';
import { Input, AlertNotice } from 'shared/components';
import * as tcRenewalAction from 'features/tc-renewal/duck';
import * as loginActions from 'core/duck';
import { INSTITUTION_STATUS } from 'shared/constants';
import './CoordinatorAgreement.scss';

const newline2br = (text) => text.replace(/(?:\r\n|\r|\n)/g, '<br>');

class CoordinatorAgreement extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checked: false,
      error: '',
    };

    this.handleContinue = this.handleContinue.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const { tcCycle, currentUser, actions, agreement } = this.props;

    if (!isEmpty(tcCycle) && isEmpty(agreement)) {
      actions.getCoordinatorAgreement(currentUser.id, tcCycle.tcStatus.status, tcCycle.cycle.id);
    }

    if (!isEmpty(agreement)) {
      this.setState({
        checked: !!agreement.agreementDate,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { agreement } = this.props;

    if (!isEmpty(agreement) && prevProps.agreement !== agreement) {
      this.setState({
        checked: !!agreement.agreementDate,
      });
    }
  }

  handleChange() {
    this.setState((prevState) => ({
      error: '',
      checked: !prevState.checked,
    }));
  }

  async handleContinue() {
    const { tcCycle, actions, currentUser, TCUrlAction, agreement } = this.props;
    const { checked } = this.state;

    if (checked) {
      let accepted = agreement.agreementDate;
      let updated;
      let newStatus;
      if (!agreement.agreementDate) {
        accepted = await actions.acceptAgreement(currentUser.id, agreement.id);
        if (accepted.message) {
          return { error: true };
        }
      }

      if (
        tcCycle.tcStatus.status === INSTITUTION_STATUS.establish ||
        tcCycle.tcStatus.status === INSTITUTION_STATUS.renewalActive
      ) {
        newStatus =
          TCUrlAction === 'establishment'
            ? INSTITUTION_STATUS.establishReview
            : INSTITUTION_STATUS.renewalReview;
        updated = await actions.updateTcStatus(tcCycle.id, {
          status: newStatus,
        });
        if (updated.message) {
          return { error: true };
        }
      }

      if (accepted && updated) {
        actions.getCoordinatorAgreement(currentUser.id, newStatus, tcCycle.cycle.id);
        return true;
      }

      return true;
    }
    this.setState({
      error: this.props.t('testCenter.terms.agreementError', {
        name: this.props.t('testCenter.terms.coordinatorTitle'),
      }),
    });
    return false;
  }

  render() {
    const { agreement } = this.props;
    const { error } = this.state;

    return (
      !isEmpty(agreement) && (
        <section className="agreement-section">
          <h4 className="mt-2">{this.props.t('testCenter.terms.coordinatorTitle')}</h4>
          <div id="terms" className="mt-4">
            <div
              className="terms-container mb-4"
              dangerouslySetInnerHTML={{ __html: newline2br(agreement.text) }}
            />
            <Input
              type="checkbox"
              name="terms"
              id="checkTerms"
              value={this.state.checked}
              onChange={this.handleChange}
              required>
              <label htmlFor="checkTerms">
                {this.props.t('testCenter.terms.coordinatorTermsLabel')}
              </label>
            </Input>
            {!!error && (
              <AlertNotice
                message={error}
                type="error"
              />
            )}
          </div>
        </section>
      )
    );
  }
}

CoordinatorAgreement.propTypes = {
  agreement: PropTypes.shape({}).isRequired,
  currentUser: PropTypes.shape({}).isRequired,
  tcCycle: PropTypes.shape({}).isRequired,
  t: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    agreement: state.tcRenewal.agreement,
    tcCycle: state.tcRenewal.tcCycle,
    currentUser: state.users.currentUser,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...tcRenewalAction, ...loginActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(withTranslation(null, { withRef: true })(CoordinatorAgreement));
